import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  vendorDashboard: {
    analytics: [],
    appointments: [],
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH,
  total: 0,
  last_page: 1,
  is_more: false,
}


export const vendorDashboardSlice = createSlice({
  name: 'vendorDashboard',
  initialState: initialState,
  reducers: {
    setVendorDashboardAnalytic: (state, { payload }) => {
      state.vendorDashboard = payload?.data ?? payload;
    },
    setVendorDashboardAnalytics: (state, { payload }) => {
      state.vendorDashboard.analytics = payload;
    },
    setVendorDashboardAppointments: (state, { payload }) => {
      state.vendorDashboard.appointments = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page
    },

    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllVendorDashboard: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})


export const fetchVendorDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchVendorDashboardAnalytics(params)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setVendorDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchVendorDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchVendorDashboardAppointments(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setVendorDashboardAppointments(result.data.data));
        console.log(result, 'reresultsuresultlt')
      } else {
        dispatch(setVendorDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))
}




export const { setVendorDashboardAnalytics, clearAllVendorDashboard, setLoader, setError, setVendorDashboardAppointments } = vendorDashboardSlice.actions

export default vendorDashboardSlice.reducer
export const VendorDashboardSelector = state => state.vendorDashboard




